declare let Plotly: any;

export const plotlyConfig = {
    modeBarButtonsToRemove: ['toImage', 'select2d', 'lasso2d', 'autoScale2d'], 
    displaylogo: false,
    responsive: true
};

export function createPlotlyChart(elementId: any, data: any, layout: any) {
    Plotly.newPlot(elementId, data, layout, plotlyConfig);
}

export function resizePlotlyChart(elementId: any) {
    Plotly.Plots.resize(elementId)
}

export function deletePlotlyChart(elementId: any) {
    Plotly.purge(elementId);
}